import { f as e, a as t, b as i, i as n, t as r, d as a, r as h, g as o, e as s, h as l, F as d, m as g, c } from "./sharedStyles.js";
import { jsx as p, jsxs as u, Fragment as x } from "react/jsx-runtime";
import { uniqueId as m } from "@wds/utils";
import { Fragment as f } from "react";
import b from "react-highlight-words";
import { createUseStyles as v } from "react-jss";
var w = t,
    z = i,
    y = n,
    j = r,
    T = a,
    O = h,
    S = o,
    I = s,
    C = l;

function M({
  response: e,
  highlightedText: t
}) {
  var i;
  const n = t === e.rendered.toLocaleLowerCase(),
        r = p(d, Object.assign({
    tooltip: null === (i = e.fuzzyMatching) || void 0 === i ? void 0 : i.tooltip
  }, {
    children: p("span", {
      children: e.rendered
    })
  }));
  return u(x, {
    children: [n && p("mark", Object.assign({
      className: "highlight"
    }, {
      children: r
    })), !n && r]
  });
}

function N({
  response: e,
  highlightedText: t
}) {
  const i = t && function (e) {
    var t;
    const i = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return `${(null === (t = e[0]) || void 0 === t ? void 0 : t.match("\\w")) ? "\\b" : ""}${i}${e[e.length - 1].match("\\w") ? "\\b" : ""}`;
  }(t);

  return u(x, {
    children: [i && p(b, {
      highlightClassName: "highlight",
      searchWords: [i],
      autoEscape: !1,
      textToHighlight: e.rendered
    }), !i && p("span", {
      children: e.rendered
    })]
  });
}

function W({
  data: e,
  highlightedText: t,
  index: i,
  showFuzzyMatching: n
}) {
  const r = e.length - 1,
        a = null == t ? void 0 : t.toLowerCase();
  return p("tr", {
    children: u("td", {
      children: [u("span", {
        children: [i + 1, ". "]
      }), e.map((e, t) => {
        var i;
        const h = n && (null === (i = e.fuzzyMatching) || void 0 === i ? void 0 : i.tooltip);
        return u(f, {
          children: [h && p(M, {
            response: e,
            highlightedText: a
          }), !h && p(N, {
            response: e,
            highlightedText: a
          }), t < r && p("span", Object.assign({
            className: "separator"
          }, {
            children: "|"
          }))]
        }, m("row-item-"));
      })]
    })
  });
}

e("match", function (e, t, i) {
  return [function (t) {
    var i = O(this),
        n = y(t) ? void 0 : S(t, e);
    return n ? w(n, t, i) : new RegExp(t)[e](T(i));
  }, function (e) {
    var n = z(this),
        r = T(e),
        a = i(t, n, r);
    if (a.done) return a.value;
    if (!n.global) return C(n, r);
    var h = n.unicode;
    n.lastIndex = 0;

    for (var o, s = [], l = 0; null !== (o = C(n, r));) {
      var d = T(o[0]);
      s[l] = d, "" === d && (n.lastIndex = I(r, j(n.lastIndex), h)), l++;
    }

    return 0 === l ? null : s;
  }];
});
const $ = v(e => ({
  individualTextResponses: Object.assign(Object.assign({}, g.table(e)), {
    width: "100%",
    textAlign: "left",
    "& th": Object.assign(Object.assign({}, g.th(e)), {
      fontSize: e.type.fontSize.body,
      padding: "12px 4px 12px 16px",
      position: "relative",
      whiteSpace: "nowrap",
      "& .highlight": {
        position: "absolute",
        right: 0,
        backgroundColor: "rgba(0, 191, 111, .25)",
        padding: "0 4px",
        fontWeight: e.type.fontWeight.regular,
        "& span": {
          fontWeight: e.type.fontWeight.medium
        }
      }
    }),
    "& td": {
      padding: "16px",
      textAlign: "left",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      display: "flex",
      height: "57px",
      boxSizing: "border-box",
      alignItems: "center",
      "& > span": {
        padding: "4px"
      },
      "& .separator": {
        color: "#9D9D9D"
      },
      "& .highlight": {
        color: e.palette.text.dark,
        backgroundColor: "rgba(0, 191, 111, .25)",
        padding: "4px",
        height: "24.5px",
        boxSizing: "border-box",
        display: "inline-flex",
        alignItems: "center"
      }
    },
    "& th, & td": {
      borderBottom: c.border.light
    }
  })
}));

function k({
  options: e = {},
  data: t = []
}) {
  const i = $();
  return t && t.length ? u("table", Object.assign({
    className: i.individualTextResponses
  }, {
    children: [p("thead", {
      children: p("tr", {
        children: u("th", {
          children: [e.header, e.highlightedText && u("span", Object.assign({
            className: "highlight"
          }, {
            children: ['"', p("span", {
              children: e.highlightedText
            }), '" mentions highlighted in green']
          }))]
        })
      })
    }), p("tbody", {
      children: t.map((t, i) => {
        var n;
        return p(W, {
          data: t.data,
          index: i,
          highlightedText: e.highlightedText,
          showFuzzyMatching: !!(null === (n = e.fuzzyMatching) || void 0 === n ? void 0 : n.enabled)
        }, m("row-"));
      })
    })]
  })) : p("div", {});
}

export { k as I };